<template>
  <form class="form-container" @submit.prevent="$emit('submitForm', $event)" novalidate>
    <slot />
  </form>
</template>

<script>

export default {
  name: 'form-form-container',
};

</script>
